var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-mb-6 predefined-dimensions"},_vm._l((_vm.dimensions),function(ref,index){
var key = ref.key;
return _c('dimension',{key:key,staticClass:"tw-w-1/5",attrs:{"type":key,"index":index,"dimensions":_vm.dimensions},on:{"select":function($event){return _vm.selected(key)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }